export const environment = {
    production: false,
    apiBaseUrl: 'https://wa-sbuga-test.azurewebsites.net',
    clientId: '7f38d7f8-3c8f-4c79-bb8b-c6f3dc31af76',
    tenantid: '7369e6ec-faa6-42fa-bc0e-4f332da5b1db',
    redirectUri: 'https://wa-sbuga-cimsauth-nonprod.azurewebsites.net/signin'
};